import { createRoute } from '@tanstack/react-router'
import { lawyerRoute } from '../index'
import { KontaktDetail } from '@/components/lawyer/kontakt-detail'

function KontaktDetailPage() {
  const { kontaktId } = lawyerKontaktDetailRoute.useParams()
  return <KontaktDetail kontaktId={parseInt(kontaktId, 10)} />
}

export const lawyerKontaktDetailRoute = createRoute({
  getParentRoute: () => lawyerRoute,
  path: '/kontakte/$kontaktId',
  component: KontaktDetailPage,
})
